import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';
const {
  SET_COMMON_DURATION_FOR_GC_REQUEST,
  SET_COMMON_DURATION_FOR_GC_FAILURE,
  SET_COMMON_DURATION_FOR_GC_SUCCESS,
} = TherapistAction;

function* setCommonDuration(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistService.setCommonDuration, action.payload);
    if (response?.status === 200) {
      yield put({ type: SET_COMMON_DURATION_FOR_GC_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: SET_COMMON_DURATION_FOR_GC_FAILURE, payload: error });
  }
}

function* setCommonDurationSaga() {
  yield takeEvery(SET_COMMON_DURATION_FOR_GC_REQUEST, setCommonDuration);
}

export default setCommonDurationSaga;
